import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { LoginService } from './services/login.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, LoginComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ocpp-fileserver-ui';


  constructor(private loginService: LoginService) { }


  logout() {
    this.loginService.logout();
  }

  get loggedIn$(){
    return this.loginService.loggedIn$;
  }
}
